module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-2-photo-1-f83a0c0f3314a85bd1b025184d56e148.webp";